<template>
  <layout>
    <h2>{{ $t('pages.contact.title') }}</h2>
    <image-block
      :image-url="image.imageUrl"
      :title="image.title"
      :text="image.text"
    />
    <form-type
      :parts="parts"
      :schema="contact"
      :post-uri="postUri"
      :success_route="{ name: 'home' }"
    />
  </layout>
</template>

<script>
  import Layout from '@/views/Default/Layout';
  import FormType from '@/components/FormType';
  import ImageBlock from '@/components/ImageBlock';

  export default {
    name: 'Contact',
    components: {
      Layout,
      FormType,
      ImageBlock,
    },
    data() {
      return {
        postUri: 'api/public/contact_us/',
        image: {
          imageUrl: '../../../static/img/bg2.jpg',
          title: this.$t('pages.contact.image_block.title'),
          text: this.$t('pages.contact.image_block.text'),
        },
        parts: [{
          formType: 'input',
          name: 'name',
          type: 'text',
          placeholder: 'form.name',
          required: true,
          isActive: true,
          label: 'form.name',
        }, {
          formType: 'input',
          name: 'email',
          type: 'email',
          placeholder: 'form.email',
          required: true,
          isActive: true,
          label: 'form.email',
        }, {
          formType: 'input',
          name: 'subject',
          type: 'text',
          placeholder: 'form.subject',
          required: false,
          isActive: true,
          label: 'form.subject',
        }, {
          formType: 'input',
          name: 'country',
          type: 'text',
          placeholder: 'form.country',
          required: false,
          isActive: true,
          label: 'form.country',
        }, {
          formType: 'textearea',
          name: 'message',
          placeholder: 'form.message',
          required: true,
          isActive: true,
          label: 'form.message',
        }],
        contact: {
          name: '',
          email: '',
          subject: '',
          message: '',
        },
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  h2 {
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Default/Contact.vue